import { recordNREvent, NEWRELIC_TABLES } from "@swiggy-private/checkout-core";

export const recordGiftingErrorNREvent = (screenType: string) => {
    recordNREvent({
        eventType: NEWRELIC_TABLES.GIFTING_CART_ERROR_SCREEN,
        screenType,
    });
};
